import * as types from './types';
import $ from 'jquery';

export const getContent = (state) => {
  $.getJSON(window.location.pathname + 'data/content.json',function(data){
    window.data = window._.assign({},data);
    data.details.forEach(function(item, index){
      item.gid = index + 1;
    });
    state.commit(types.GET_CONTENT, data);
  });
};

export const routeChange = (state, prevRoute) => {
  state.commit(types.ROUTE_CHANGE, prevRoute);
};

export const preloading = (state) => {
  state.commit(types.IS_PRELOADING);
};

export const preloaded = (state) => {
  state.commit(types.HAS_PRELOADED);
};

export const preloadedHalf = (state) => {
  state.commit(types.HAS_PRELOADED_HALF);
};

export const logoAnimated = (state) => {
  state.commit(types.LOGO_ANIMATED);
};

export const toggleClass = (state, className) => {
  state.commit(types.TOGGLE_CLASS, className);
};

export const showNav = (state) => {
  state.commit(types.SHOW_NAV);
};

export const hideNav = (state) => {
  state.commit(types.HIDE_NAV);
};

export const notTouchDevice = (state) => {
  state.commit(types.NOT_TOUCH_DEVICE);
};



// WEBPACK FOOTER //
// ./C:/projects/okinawa/be-okinawa/src/js/store/actions.js